import type { components } from "@/shared/api/generated/openapi";

type IngestStatus = components["schemas"]["IngestStatusOut"];

// Статус программы проверяет фоновая задача. Перезапрашиваем раз в 5 секунд, пока проверка
// идёт (`pending`), но не больше минуты: дальше статус обновит следующий заход на страницу.
export const INGEST_POLL_INTERVAL_MS = 5_000;
export const INGEST_POLL_MAX_FETCHES = 12;

export const isIngestChecking = (data: IngestStatus | undefined, fetchCount: number): boolean =>
  data?.pending === true && fetchCount < INGEST_POLL_MAX_FETCHES;
